import createHTMLMediaHook from './util/createHTMLMediaHook';
var useAudio = createHTMLMediaHook('audio');
export default useAudio;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useAudio.js
// module id = +4/Y
// module chunks = 0